"use client";
import Image from "next/image";
import QRCode from "react-qr-code";
import { useState, useEffect } from "react";
export default function Hero_Section() {
  const [isSafari, setIsSafari] = useState(false);
  const [hovered, setHovered] = useState(false);
  useEffect(() => {
    // Detect Safari browser
    const userAgent = navigator.userAgent;
    const isSafariBrowser = /^((?!chrome|android).)*safari/i.test(userAgent);
    setIsSafari(isSafariBrowser);

  }, []);

  return (
    <div className="relative w-full h-auto overflow-hidden">
      {/* Background Image for Faster LCP */}
      <Image
        src="/hero_section/headerv2.svg"
        alt="Header Background"
        fill
        style={{ objectFit: "cover" }}
        priority
      />

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full">
        <div className="w-full flex justify-center py-7 px-5 lg:px-10 md:px-10">
          <span className="text-[30px] w-full lg:w-2/3 md:w-2/3 leading-none lg:text-[80px] md:text-[60px] font-bold text-center">
            Get <span className="text-[#1CBFA2] text-nowrap">2nd Line</span>
            <br />
            application
          </span>
        </div>
        <div className="w-full flex justify-center text-[10px] lg:text-[18px] md:text-[16px] px-5 text-center">
          <h2 className="w-full lg:w-1/2 md:w-1/2">
            2nd Line phone number for work, dating, or privacy. Call & text
            without extra SIMs. Stay connected & in control with one easy app!
          </h2>
        </div>
        <div className="w-full  justify-between  px-20 hidden lg:flex ">
          <div className="flex space-x-2 justify-end items-end relative pb-10">
            {/* Download App */}
            <a
              href="https://apps.apple.com/us/app/second-phone-number-2nd-line/id1607181162"
              target="_blank"
              rel="noopener noreferrer"
              title="Download Second Phone Number app on the App Store"
              className="rounded-full border border-black p-3 flex items-center transition-all duration-300 hover:bg-[#1CBFA2] hover:border-white text-[#060A1F] hover:text-white text-[18px]  cursor-pointer text-nowrap"
            >
              Download App
            </a>

            {/* Apple Icon */}
            <a
              className="group rounded-full border cursor-pointer border-black p-3 flex items-center hover:bg-[#1CBFA2] hover:border-white hover:text-white"
              href="https://apps.apple.com/us/app/second-phone-number-2nd-line/id1607181162"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image
                src="/appstore_icons/apple.svg"
                width={20}
                height={20}
                alt="apple"
               
                    className="filter group-hover:invert group-hover:brightness-0 group-hover:contrast-200 transition-all duration-300 mx-[2px]"
              />
            </a>
          </div>
          <div className="h-[353px]">
           
              {isSafari ? (
                <object
                  type="image/svg+xml"
                  data="/second_line_mobile_images/mobile_image_for_hero_section.svg"
                  width="580"
                  height="353"
                  aria-label="Mockup of the 2nd Line application interface"
                ></object>
              ) : (
                <Image
                  src="/second_line_mobile_images/mobile_image_for_hero_section.svg"
                  alt="Mockup of the 2nd Line application interface"
                  width={580}
                  height={353}
                />
              )}
          </div>

          {/* <Mockup className=" h-auto pl-16 lg:pl-12 md:pl-7 bottom-0" /> */}
          <div className="flex space-x-2 justify-end items-end relative pb-10 hover:text-[#1CBFA2]">
            <div
              className="cursor-pointer"
              onMouseEnter={() => setHovered(true)}
              onMouseLeave={() => setHovered(false)}
            >
              <div className="bg-white p-3 rounded-2xl shadow-xl border border-gray-200">
                <QRCode
                  value="https://apps.apple.com/us/app/second-phone-number-2nd-line/id1607181162"
                  size={80}
                  bgColor="white"
                  fgColor={hovered ? "#1CBFA2" : "#000000"}
                  level="L"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="block lg:hidden ">
          <div className="flex space-x-2 justify-center items-end relative space-y-2 py-5">
            <a
              href="https://apps.apple.com/us/app/second-phone-number-2nd-line/id1607181162"
              target="_blank"
              rel="noopener noreferrer"
              title="Download Second Phone Number app on the App Store"
              className="rounded-full border border-black p-3 flex items-center transition-all duration-300 hover:bg-[#1CBFA2] hover:border-white text-[#060A1F] hover:text-white text-[18px]  cursor-pointer"
            >
              Download App
            </a>

            {/* Apple Icon */}
            <a
              className="group rounded-full border cursor-pointer border-black p-3 flex items-center hover:bg-[#1CBFA2] hover:border-white hover:text-white"
              href="https://apps.apple.com/us/app/second-phone-number-2nd-line/id1607181162"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image
                src="/appstore_icons/apple.svg"
                width={20}
                height={20}
                alt="apple"
                
                    className="filter group-hover:invert group-hover:brightness-0 group-hover:contrast-200 transition-all duration-300 mx-[2px]"
              />
            </a>
          </div>

          {/* <Image
        src="/testing.svg" // No need for import!
        alt="Mockup"
        width={0}
        height={0}
        className="pl-16 mb-0 w-auto h-auto"
        style={{imageRendering:"pixelated"}}
        unoptimized
      /> */}
          <div className="relative flex justify-center items-center">
            {isSafari ? (
              <object
                type="image/svg+xml"
                data="/second_line_mobile_images/mobile_image_for_hero_section.svg"
                aria-label="Mockup of the application interface"
                className="max-w-full h-auto justify-center flex pl-16"
              ></object>
            ) : (
              <Image
                src="/second_line_mobile_images/mobile_image_for_hero_section.svg"
                alt="Mockup"
                width={400}
                height={200}
                className="max-w-full h-auto justify-center flex pl-16"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
